import {
  AgAirline,
  AgCommodity,
  AgInput,
  AgSelect,
  AgSelect1,
  AgUnloc,
  EmailListComp,
  VanishMessage,
} from "./components/AgComponents";
import Api from "./state/Api";
import { Columns, Col, Col2, Col3, Col4, Col6, Col12 } from "./Controls";
import CargoComp from "./CargoComp";
import AgTable from "./components/AgTable";
import {
  packingGroupList,
  getHazardousClassList,
  getStaticConsolidatorList,
  stuffingTypes,
  deStuffingTypes,
} from "./StaticData";
import {
  configStore,
  quoteDataRec,
  toEmailStore,
  ccEmailStore,
  chargesStore1,
  airChargesStore,
  customerStore,
  entityStore,
  aguserStore,
  loginStore,
  multiSelectListStore,
  dataListStore,
  modalStore,
} from "./state/CommonState";
import { containerStore, cargoStore } from "./state/CommonState";
import {
  shipmentTypeList,
  shipmentScopeList,
  incoTermsList,
} from "./StaticData";
import { useSnapshot } from "valtio";
import ContainerComp from "./ContainerComp";
import ChargesComp from "./ChargesComp";
import { chargesData, chargesData1 } from "./StaticData";
import { chargesStore, fclChargesStore } from "./state/CommonState";
import FCLChargesComp from "./FCLChargesComp";
import Utils from "./util/Utils";
import ChargesComp1 from "./ChargesComp1";
import AgCustlist from "./components/AgCustlist";
import { useEffect, useLayoutEffect, useState, useRef } from "react";
import ChargesAirComp from "./ChargesAirComp";
import AddCustomer from "./AddCustomer";
import { Agyesno } from "./components/Agyesno";
import {
  AgMultiSelectWithCheckBoxes,
  AgSelectWithMap,
} from "./components/AgCustomComponents";
import {
  chargesValidationStore,
  QuotationValidationStore,
} from "./state/validation-stores";
import QuotationUtils from "./util/quotationUtil";
import AguserApi from "./state/AguserApi.js";
import { AgGoogleMap, AgUnlocde } from "./components/ag-address/ag-address";

export default function Quote() {
  useSnapshot(configStore);
  useSnapshot(customerStore);
  useSnapshot(multiSelectListStore);
  useSnapshot(dataListStore);
  useSnapshot(containerStore);
  useSnapshot(modalStore);
  const selectedConsolidatorList = getStaticConsolidatorList();
  const consolidatorListKey = "consolidatorList";
  const [space, setSpace] = useState("");
  const [cursor, setCursor] = useState(0);
  const ref = useRef(null);
  const getExchangerates = async( ) =>{
    await Api.getExchangerates()
  }
  useEffect(() => {
    console.log("Inside useEffect of Quote ");
    getExchangerates()
    Api.getFCLCarrierList();
    AguserApi.getList();
  }, []);
  useEffect(() => {
    const input = ref.current;
    if (input) {
      input.setSelectionRange(cursor, cursor);
    }
  }, [ref, cursor]);
  const handleChange = (e) => {
    setCursor(e.target.selectionStart);
    quoteDataRec.customTC = e.target.value;
  };
  console.log(quoteDataRec);
  useLayoutEffect(() => {
    if (
      quoteDataRec?.shipmentType != "" &&
      quoteDataRec?.shipmentType.toLowerCase().includes("lcl")
    ) {
      if (!quoteDataRec?.quotationNum && quoteDataRec?.consolidatorList == null)
        quoteDataRec.consolidatorList = selectedConsolidatorList;
      multiSelectListStore.selectList[consolidatorListKey] =
        selectedConsolidatorList.map(({ consolidatorAbbrName }) => ({
          id: consolidatorAbbrName,
          name: consolidatorAbbrName,
          checked: quoteDataRec.consolidatorList
            .map((addedConsolidator) => addedConsolidator.consolidatorAbbrName)
            .includes(consolidatorAbbrName),
        }));
    } else quoteDataRec.consolidatorList = null;
  }, [quoteDataRec.consolidatorList, quoteDataRec.shipmentType]);
  useEffect(() => {
    setSpace(space === "" ? " " : "");
  }, [containerStore.list, containerStore.newRec]);
  useSnapshot(quoteDataRec);
  useSnapshot(QuotationValidationStore);
  //console.log('from inside Quote. currency list = ', configStore.currencyList, configStore.getExchangeRate('USD'), 'erate')
  const _params = (label, name, type = "text", dataList = []) => {
    return {
      type,
      name,
      label,
      record: quoteDataRec,
      dataList,
    };
  };
  const factoryOrDock = (shipmentType) => {
    if (shipmentType.indexOf("FCL") < 0) return <></>;
    let label = "Stuffing Type";
    if (shipmentType.indexOf("De-stuffing") >= 0) label = "De-stuffing Type";
    let listOfValues = ["", "Factory", "Dock"];
    if (shipmentType.indexOf("Dock") >= 0) listOfValues = ["", "Dock"];
    if (shipmentType.indexOf("Factory") >= 0) listOfValues = ["", "Factory"];
    return (
      <Col3>
        <AgSelect
          {..._params(label, "factoryOrDockStuffing", "select", listOfValues)}
        />
      </Col3>
    );
  };
  const displayNonStackable = (st, sc) => Utils.displayNonStackable(st, sc);
  const portOfLoadingLabel =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Origin Airport"
      : "* Port of Loading";
  const portOfDischargeLabel =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Destination Airport"
      : "Port of Discharge";
  const displayReferenceNumber = () => {
    if (quoteDataRec.quotationNum)
      return "Reference#: " + quoteDataRec.quotationNum;
    return "";
  };

  if (quoteDataRec.shipmentType.indexOf("LCL") >= 0) {
    if (!quoteDataRec.carrier) quoteDataRec.carrier = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE;
  }
  let isDisabled = {};

  console.log();
  return (
    <>
      <div className="container is-fullheight">
        <div
          className="box"
          style={{
            top: 0,
            zIndex: 4,
            marginTop: "0px",
            position: "sticky",
            backgroundColor: "#eeeeff",
            padding: "0.2rem",
          }}>
          <Columns>
            <Col3>
              <h1 className="title">Quotation</h1>
              {displayReferenceNumber()}
            </Col3>
            <Col3>
              <AgSelect1
                {..._params(
                  "* Shipment Type",
                  "shipmentType",
                  "select",
                  shipmentTypeList
                )}
                isValid={
                  QuotationValidationStore.quotationValidMap["shipmentType"]
                }
                validationMsg="- Please select one of shipment types."
                isDisabled={
                  configStore.disableShipmentType !== ""
                    ? { disabled: true }
                    : {}
                }
                callback={(stype) => {
                  QuotationValidationStore.validate("shipmentType");
                  const data = chargesData[stype.substr(0, 3).toLowerCase()];
                  const data1 = chargesData1[stype.substr(0, 3).toLowerCase()];
                  console.log("Inside the new call back", stype, data1);
                  if (data1 && data1.initialLength) {
                    if (stype.indexOf("FCL") >= 0) {
                      fclChargesStore.colNames = data1.colNames;
                      fclChargesStore.initialLength = data1.initialLength;
                      fclChargesStore.list = data1.preList;
                    } else if (stype.indexOf("Air") >= 0) {
                      airChargesStore.initialLength = data1.initialLength;
                      airChargesStore.list = data1.preList;
                    } else {
                      //chargesStore.colNames = data.colNames
                      //chargesStore.initialLength = data.initialLength
                      //chargesStore.list = data.preList
                      chargesStore1.initialLength = data1.initialLength;
                      chargesStore1.list = data1.preList;
                      quoteDataRec.carrier = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE;
                    }
                  } else {
                    chargesStore.initialLength = 0;
                    chargesStore.list = [];
                    chargesStore1.initialLength = 0;
                    chargesStore1.list = [];
                    airChargesStore.initialLength = 0;
                    airChargesStore.list = [];
                  }
                }}
              />
            </Col3>
            <Col2>
              <AgSelect
                {..._params(
                  "* Shipment Scope",
                  "shipmentScope",
                  "select",
                  shipmentScopeList
                )}
                isValid={
                  QuotationValidationStore.quotationValidMap["shipmentScope"]
                }
                callback={() =>
                  QuotationValidationStore.validate("shipmentScope")
                }
                validationMsg="- Please select one of shipment scopes."
                isDisabled={
                  quoteDataRec.quotationNum !== "" ? { disabled: false } : {}
                }
              />
            </Col2>
            <Col4>
              <AgCustlist
                {..._params("* Customer", "entity", "select", entityStore.list)}
                isValid={QuotationValidationStore.quotationValidMap["entity"]}
                validationMsg="- Please select one of customers."
                isDisabled={
                  quoteDataRec.quotationNum !== "" ? { disabled: true } : {}
                }
                callback={(gst) => {
                  QuotationValidationStore.validate("entity");
                  let entity = entityStore.list.filter((e) => e.gst === gst);
                  console.log("FOUND ENTITY = ", entity);
                  if (entity.length > 0) {
                    let email = entity[0].salesPerson;
                    quoteDataRec.salesperson = aguserStore.getName4email(email);
                    email = entity[0].customerService;
                    if (email)
                      quoteDataRec.customerService =
                        aguserStore.getName4email(email);
                    quoteDataRec.customerEmail = entity[0].admin;
                    quoteDataRec.gst = gst;
                  }
                }}
              />
            </Col4>
            {/*<Col>
                            <button className="button is-danger" onClick={() => {
                                configStore.addNewCustomerVisible = true
                            }}>
                                <span className="icon">
                                    <i className="fas fa-plus"></i>
                                </span>
                            </button>
                        </Col>*/}
          </Columns>
        </div>
        {configStore.addNewCustomerVisible ? (
          <Columns>
            <Col12>
              <AddCustomer />
            </Col12>
          </Columns>
        ) : (
          <></>
        )}
        <Columns>
          <Col3>
            <AgInput {..._params("Sales Person", "salesperson")} />
          </Col3>
          <Col3>
            {/* {
                            ['Port-to-Port', 'Port-to-Door'].includes(quoteDataRec.shipmentScope)
                            ? <AgUnloc {..._params('Origin', 'origin')} />
                            : <AgInput {..._params('Origin', 'origin')} />
                        } */}
            {quoteDataRec.shipmentScope === "Port-to-Port" ||
              quoteDataRec.shipmentScope === "Port-to-Door" ||
              quoteDataRec.shipmentScope === "" ? (
              <AgUnlocde
                {..._params("* Origin", "origin")}
                isValid={QuotationValidationStore.quotationValidMap["origin"]}
                callback={() => QuotationValidationStore.validate("origin")}
                validationMsg={QuotationValidationStore.orginmsg}
              />
            ) : (
              <AgGoogleMap
                isDisabled={isDisabled}
                label={"* Origin"}
                record={quoteDataRec}
                name={"origin"}
                ShipmentType={quoteDataRec.shipmentScope}
              />
            )}

            {/* || quoteDataRec.shipmentScope === 'Port-to-Door' */}
            {/* <AgUnloc {..._params('* Origin', 'origin')}  isValid = {QuotationValidationStore.quotationValidMap['origin']} callback = {() => QuotationValidationStore.validate('origin') } validationMsg = {QuotationValidationStore.orginmsg} /> */}
          </Col3>
          <Col3>
            {/* {
                            ['Port-to-Port', 'Door-to-Port'].includes(quoteDataRec.shipmentScope)
                            ? <AgUnloc {..._params('Destination', 'destination')} />
                            : <AgInput {..._params('Destination', 'destination')} />
                        } */}
            {quoteDataRec.shipmentScope === "Door-to-Door" ||
              quoteDataRec.shipmentScope === "Port-to-Door" ? (
              <AgGoogleMap
                isDisabled={isDisabled}
                label={"* Destination"}
                record={quoteDataRec}
                name={"destination"}
                ShipmentType={quoteDataRec.shipmentScope}
              />
            ) : (
              <AgUnlocde
                {..._params("* Destination", "destination")}
                isValid={
                  QuotationValidationStore.quotationValidMap["destination"]
                }
                callback={() =>
                  QuotationValidationStore.validate("destination")
                }
                validationMsg={QuotationValidationStore.destinationmsg}
              />
            )}

            {/* || quoteDataRec.shipmentScope === 'Door-to-Port' */}
          </Col3>
          <Col3>
            <AgInput
              {..._params(
                "* Cargo Readiness Date",
                "cargoReadinessDate",
                "date"
              )}
              isValid={
                QuotationValidationStore.quotationValidMap["cargoReadinessDate"]
              }
              callback={() =>
                QuotationValidationStore.validate("cargoReadinessDate")
              }
              validationMsg="- Please pick valid date."
            />
          </Col3>
        </Columns>
        <Columns>
          {quoteDataRec.shipmentType.indexOf("Air") < 0 ? (
            <Col3>
              <AgUnloc
                {..._params("Place of Receipt", "portOfReceipt")}
                isValid={
                  QuotationValidationStore.quotationValidMap["portOfReceipt"]
                }
                callback={() =>
                  QuotationValidationStore.validate("portOfReceipt")
                }
              />
            </Col3>
          ) : (
            <Col3>
              {/*<AgInput {..._params('Airline', 'airline')} />*/}
              <AgAirline
                label="* Airline"
                record={quoteDataRec}
                name="airline"
                isValid={QuotationValidationStore.quotationValidMap["airline"]}
                callback={() => QuotationValidationStore.validate("airline")}
                validationMsg="- Please select one airline."
              />
            </Col3>
          )}
          <Col3>
            <AgUnloc
              {..._params(portOfLoadingLabel, "portOfLoading")}
              isValid={
                QuotationValidationStore.quotationValidMap["portOfLoading"]
              }
              callback={() =>
                QuotationValidationStore.validate("portOfLoading")
              }
            />
          </Col3>
          <Col3>
            <AgUnloc
              {..._params(portOfDischargeLabel, "portOfDischarge")}
              isValid={
                QuotationValidationStore.quotationValidMap["portOfDischarge"]
              }
              callback={() =>
                QuotationValidationStore.validate("portOfDischarge")
              }
            />
          </Col3>
          {quoteDataRec.shipmentType.indexOf("Air") < 0 ? (
            <Col3>
              <AgUnloc
                {..._params(
                  "* Final Place of Delivery",
                  "finalPlaceOfDelivery"
                )}
                isValid={
                  QuotationValidationStore.quotationValidMap[
                  "finalPlaceOfDelivery"
                  ]
                }
                callback={() =>
                  QuotationValidationStore.validate("finalPlaceOfDelivery")
                }
                validationMsg="- Please select enter valid UN location."
              />
            </Col3>
          ) : (
            <></>
          )}
        </Columns>
        <Columns>
          <Col3>
            <AgInput
              {..._params("Customer Reference #", "customerReferenceNum")}
            />
          </Col3>
          <Col3>
            <AgInput
              {..._params("* Valid Upto", "validUpto", "date")}
              isValid={QuotationValidationStore.quotationValidMap["validUpto"]}
              callback={() => QuotationValidationStore.validate("validUpto")}
              validationMsg="- Please pick valid data."
            />
          </Col3>
          <Col3>
            <AgCommodity
              h={quoteDataRec.hazardous}
              {..._params("Commodity Type", "commodityType")}
            />
          </Col3>
          <Col3>
            <AgSelect
              {..._params("Incoterms", "incoTerms", "select", incoTermsList)}
            />
          </Col3>
        </Columns>
        <Columns>
          {!displayNonStackable(
            quoteDataRec.shipmentType,
            quoteDataRec.shipmentScope
          ) ? (
            <></>
          ) : (
            <Col3>
              <Agyesno
                label="Non Stackable"
                record={quoteDataRec}
                name="nonStackable"
              />
            </Col3>
          )}
          {/* <Col3>
                        <AgInput {..._params('Carrier', 'carrier')} />
                    </Col3> */}

          {quoteDataRec.shipmentType
            .toString()
            .toLowerCase()
            .includes("fcl") && (
              <Col3>
                <AgSelectWithMap
                  label={"* Carrier"}
                  record={quoteDataRec}
                  name="carrier"
                  dataMap={dataListStore["FCLCarrierList"].map((carrier) => ({
                    key: carrier["Display Name"],
                    value: `${carrier["Display Name"]} (${carrier["SCAC code"]})`,
                  }))}
                  isValid={QuotationValidationStore.quotationValidMap["carrier"]}
                  callback={() => QuotationValidationStore.validate("carrier")}
                  validationMsg="- Please pick valid carrier."
                />
              </Col3>
            )}

          {quoteDataRec.shipmentType
            .toString()
            .toLowerCase()
            .includes("lcl") && (
              <Col3>
                <AgMultiSelectWithCheckBoxes
                  label={"* Consolidator"}
                  storeKey={consolidatorListKey}
                  callback={() => {
                    quoteDataRec.consolidatorList =
                      multiSelectListStore.selectList[consolidatorListKey]
                        .filter(({ checked }) => checked)
                        .map(({ id }) =>
                          selectedConsolidatorList.find(
                            ({ consolidatorAbbrName }) =>
                              consolidatorAbbrName === id
                          )
                        );
                  }}
                  withAllShortcut></AgMultiSelectWithCheckBoxes>
              </Col3>
            )}

          <Col3>
            <AgInput
              {..._params("* Tentative transit Time", "transitTime", "number")}
              isValid={
                QuotationValidationStore.quotationValidMap["transitTime"]
              }
              callback={() => QuotationValidationStore.validate("transitTime")}
              validationMsg="- Please enter valid transit time."
            />
          </Col3>
        </Columns>
        <Columns>
          <Col3>
            <Agyesno
              label="Hazardous"
              record={quoteDataRec}
              name="hazardous"
              isDisabled={
                quoteDataRec.temperatureControlled.toLowerCase() === "yes"
              }
              callback={(value) => {
                if (value === "No") {
                  quoteDataRec.quoteClass = "";
                  quoteDataRec.packingGroup = "";
                  quoteDataRec.unnumber = "";
                }
              }}
            />
          </Col3>
          {quoteDataRec.hazardous === "Yes" ? (
            <>
              <Col3>
                <AgSelect
                  {..._params(
                    "* Class",
                    "quoteClass",
                    "select",
                    getHazardousClassList(quoteDataRec.shipmentType)
                  )}
                  isValid={
                    QuotationValidationStore.quotationValidMap["quoteClass"]
                  }
                  callback={() =>
                    QuotationValidationStore.validate("quoteClass")
                  }
                  validationMsg="- Please enter select valid class."
                />
              </Col3>
              <Col3>
                <AgSelect
                  {..._params(
                    "* Packing Group",
                    "packingGroup",
                    "select",
                    packingGroupList
                  )}
                  isValid={
                    QuotationValidationStore.quotationValidMap["packingGroup"]
                  }
                  callback={() =>
                    QuotationValidationStore.validate("packingGroup")
                  }
                  validationMsg="- Please enter select valid packing group."
                />
              </Col3>
              <Col3>
                <AgInput
                  {..._params("* UN Number", "unnumber", "text")}
                  isValid={
                    QuotationValidationStore.quotationValidMap["unnumber"]
                  }
                  callback={() => QuotationValidationStore.validate("unnumber")}
                  validationMsg="- Please enter valid unnumber "
                />
              </Col3>
            </>
          ) : (
            <></>
          )}
        </Columns>
        <Columns>
          {quoteDataRec.isFromEnquiry &&
            quoteDataRec.shipmentType.toLowerCase().includes("fcl") && (
              <>
                <Col3>
                  <AgSelect1
                    {..._params(
                      "Stuffing type",
                      "stuffingType",
                      "select",
                      stuffingTypes
                    )}
                    isDisabled={{ disabled: true }}
                  />
                </Col3>
                <Col3>
                  <AgSelect1
                    {..._params(
                      "De-Stuffing type",
                      "deStuffingType",
                      "select",
                      deStuffingTypes
                    )}
                    isDisabled={{ disabled: true }}
                  />
                </Col3>
              </>
            )}
          {/* {
                      ( quoteDataRec.shipmentType    
                        .toString()
                        .toLowerCase()
                        .includes("fcl")) ? <>
                        <Col3 style={{display:'none'}}>
                        <Agyesno label='Do you require a Direct Carrier MBL?' record={quoteDataRec}
                            name='carrierMBL' 
                            // isDisabled = { quoteDataRec.carrierMBL.toLowerCase() === 'yes'  } callback = { (value) => {}}
                            isDisabled = {quoteDataRec.isFromEnquiry ? true : false}
                            />
                        </Col3>
                        </> : <></>
                    } */}
          {Utils.displayTemperatureControlled(quoteDataRec.shipmentType) &&
            modalStore.disableTemp === false ? (
            <>
              <Col3>
                <Agyesno
                  label={`${space}Temperature Controlled?`}
                  record={quoteDataRec}
                  name="temperatureControlled"
                  isDisabled={
                    quoteDataRec.hazardous.toLowerCase() === "yes" ||
                      quoteDataRec.shipmentType.toLowerCase().includes("fcl")
                      ? containerStore.list.length > 0 ||
                      containerStore.newRec.containerType !== ""
                      : false
                  }
                  callback={(value) => {
                    if (value === "No") {
                      quoteDataRec.minTemperature = 0;
                      quoteDataRec.maxTemperature = 0;
                      quoteDataRec.temperature = 0;
                      quoteDataRec.cargoValue = 0;
                    }
                  }}
                />
                {/*<AgSelect {..._params('Temperature Controlled?',
                                        'temperatureControlled', 'select', ['', 'Yes', 'No'])} />*/}
              </Col3>
            </>
          ) : (
            <></>
          )}
          {
            (() => {
              if (
                Utils.displayTemperatureControlled(quoteDataRec.shipmentType) &&
                quoteDataRec.temperatureControlled === "Yes"
              ) {
                if (quoteDataRec.shipmentType.toLowerCase().includes("air"))
                  return (
                    <>
                      <Col3>
                        <AgInput
                          {..._params(
                            "* Minimum Temperature",
                            "minTemperature",
                            "number"
                          )}
                          isValid={
                            QuotationValidationStore.quotationValidMap[
                            "minTemperature"
                            ]
                          }
                          callback={() =>
                            QuotationValidationStore.validate("minTemperature")
                          }
                          validationMsg={`- Please enter valid temperature should be greater than -35 .
                                                    `}
                        />
                      </Col3>
                      <Col3>
                        <AgInput
                          {..._params(
                            "* Maximum Temperature",
                            "maxTemperature",
                            "number"
                          )}
                          isValid={
                            QuotationValidationStore.quotationValidMap[
                            "maxTemperature"
                            ]
                          }
                          callback={() =>
                            QuotationValidationStore.validate("maxTemperature")
                          }
                          validationMsg="- Please enter valid temperature should be less than 30 "
                        />
                      </Col3>
                    </>
                  );
                return (
                  <>
                    <Col3>
                      <AgInput
                        {..._params("* Temperature", "temperature", "number")}
                        isValid={
                          QuotationValidationStore.quotationValidMap[
                          "temperature"
                          ]
                        }
                        callback={() =>
                          QuotationValidationStore.validate("temperature")
                        }
                        validationMsg={`- Please enter valid temperature and range should be between (-)35 ⁰C to (+)30 ⁰C.
                                                    `}
                      />
                    </Col3>
                    <Col3>
                      <AgInput
                        {..._params(
                          "* Cargo Value (USD)",
                          "cargoValue",
                          "number"
                        )}
                        isValid={
                          QuotationValidationStore.quotationValidMap[
                          "cargoValue"
                          ]
                        }
                        callback={() =>
                          QuotationValidationStore.validate("cargoValue")
                        }
                        validationMsg="- The value should be less than US$ 100,000."
                      />
                    </Col3>
                  </>
                );
              }
              return <></>;
            })()
            // (Utils.displayTemperatureControlled(quoteDataRec.shipmentType) &&
            //     quoteDataRec.temperatureControlled === 'Yes') ?
            //     <>
            //         <Col3>
            //             <AgInput {..._params('Temperature', 'temperature', 'number')} isDisabled = { quoteDataRec.isFromEnquiry ? {disabled: true} : {}}
            //                 isValid = {QuotationValidationStore.quotationValidMap['temperature']}  callback = {() => QuotationValidationStore.validate('temperature')} validationMsg = {`- Please enter valid temperature and range should be between -35 to +30.
            //                 `}/>
            //         </Col3>
            //         <Col3>
            //             <AgInput {..._params('Cargo Value (USD)', 'cargoValue', 'number')} isDisabled = { quoteDataRec.isFromEnquiry ? {disabled: true} : {}}
            //                 isValid = {QuotationValidationStore.quotationValidMap['cargoValue']}  callback = {() => QuotationValidationStore.validate('cargoValue')} validationMsg = "- The value should be less than 100,000."/>
            //         </Col3>
            //     </> : <></>
          }
        </Columns>
        {quoteDataRec.shipmentType.indexOf("FCL") >= 0 ? (
          <ContainerComp />
        ) : (
          <></>
        )}

        {Utils.displayNonStackable(
          quoteDataRec.shipmentType,
          quoteDataRec.shipmentScope
        ) && QuotationUtils.hasCargoDetail() ? (
          <CargoComp />
        ) : (
          <></>
        )}
        {quoteDataRec.shipmentType.indexOf("LCL") >= 0 ? (
          <ChargesComp1 />
        ) : (
          <></>
        )}
        {quoteDataRec.shipmentType.indexOf("Air") >= 0 ? (
          <ChargesAirComp />
        ) : (
          <></>
        )}
        {quoteDataRec.shipmentType.indexOf("FCL") >= 0 ? (
          <FCLChargesComp />
        ) : (
          <></>
        )}
        <Columns>
          <Col12>
            <h3 className="title is-5">Custom Terms & Conditions</h3>
            {/* <textarea value={quoteDataRec.customTC}
                            onChange={(e) => quoteDataRec.customTC = e.target.value}
                            class="textarea" placeholder=""></textarea> */}
            <textarea
              ref={ref}
              value={quoteDataRec.customTC}
              onChange={handleChange}
              class="textarea"
              placeholder=""
            />
          </Col12>
        </Columns>
        <Columns>
          <Col12>
            <div className="field is-grouped">
              <div className="control">
                <button
                  className="button"  style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                  onClick={() => {
                    chargesValidationStore.onSaveBtnClicked();
                    console.log(QuotationValidationStore.message, ' QuotationValidationStore.message');
                    if (
                      quoteDataRec.shipmentType.toLowerCase().includes("lcl")
                    ) {
                      console.log(
                        "#########3",
                        quoteDataRec.consolidatorList.length
                      );
                      // alert("test")

                      if (quoteDataRec.consolidatorList.length < 1) {

                        configStore.setModalMessage(
                          `Please add atleast one consolidator`
                        );
                      } else {
                        console.log("checking", QuotationValidationStore.isValid(),QuotationValidationStore.message);
                        if (QuotationValidationStore.isValid())
                          Api.saveQuote("DRAFT");
                        else
                          configStore.setModalMessage(
                            QuotationValidationStore.message
                          );
                      }
                      return;
                    } else {
                      if (QuotationValidationStore.isValid())
                        Api.saveQuote("DRAFT");
                      else
                        configStore.setModalMessage(
                          QuotationValidationStore.message
                        );
                    }

                    //console.log('submit===', quoteDataRec)
                  }}>
                  Save
                </button>
              </div>
            </div>
          </Col12>
        </Columns>
      </div>
    </>
  );
}
